// @flow
import * as React from 'react';
import Card from 'components/Card';
import SocialCollectionLandingPage from 'assets/SocialCollectionLandingPage.jpg';

const GetAccess = () => {
  return (
    <Card>
      <div className="ph6 pv4 flex flex-column items-center">
        <img className="w-75" src={SocialCollectionLandingPage} alt="" />
        <h1 className="tc b mt3 mb2 brandon" style={{ fontSize: 24 }}>
          Your brand advocates are posting. Capture their content.
        </h1>
        <p className="tc fw1 mv2 lh-copy gray" style={{ fontSize: 16 }}>
          Social Collection enables you to collect and display the images and
          videos your customers are posting of your products on Instagram.
        </p>
        <a
          className="link mv2"
          style={{ fontSize: 16 }}
          target="_"
          href="https://www.powerreviews.com/software-products/social-suite/"
        >
          Learn More
        </a>
      </div>
      <div className="pa4 flex flex-column items-center bg-light-gray">
        <h2 className="b mv2 brandon" style={{ fontSize: 20 }}>
          Interested in Getting Started?
        </h2>
        <p className="fw1 mv2 gray" style={{ fontSize: 16 }}>
          Talk to your Client Success Director today to enable Social Collection
          for your account.
        </p>
      </div>
    </Card>
  );
};

export default GetAccess;



// WEBPACK FOOTER //
// ./src/containers/socialcollection/GetAccess.js